import { AuthUser } from '@/models/AuthModels';

export type State = {
  authUser: AuthUser | null;
};

export const state: State = {
  authUser: localStorage.getItem('authUser') != null && localStorage.getItem('authUser') !== undefined ? JSON.parse(localStorage.authUser) : null,
};
